import { gql } from '@apollo/client'

export const DEVIS_FOURNISSEUR_MUTATION = gql`
  mutation DevisFournisseur($id: bigint!, $data: d4_devisfournisseur_set_input!) {
    devisfournisseur: update_d4_devisfournisseur_by_pk(pk_columns: { id: $id }, _set: $data) {
      id
      demandedevisfournisseur {
        demandedevis {
          id
        }
      }
    }
  }
`
